import { AlertDialog } from '@/components/ds2'

interface ConfirmDocumentRemovalDialogProps {
    /** The document asked about; none while the dialog is closed. */
    fileName: string | null
    /** What removing it does, when the profile says more than the default (a vehicle's shared document). */
    description?: string
    onClose: () => void
    onConfirm: () => void
}

/** "Remove this document?" for a saved profile document: the one confirmation, whether HR removes it from its chip or from a card's AI status. */
export const ConfirmDocumentRemovalDialog = ({ fileName, description, onClose, onConfirm }: ConfirmDocumentRemovalDialogProps) => (
    <AlertDialog
        open={fileName !== null}
        onClose={onClose}
        title="Remove this document?"
        description={fileName === null ? '' : (description ?? `${fileName} will be permanently deleted from this profile. This cannot be undone.`)}
        confirmLabel="Remove"
        onConfirm={onConfirm}
    />
)
